var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      zoom: 1.3,
      marginLeft: "-2px"
    },
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4ZM7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7ZM9.92597 14.2049C10.1345 14.7163 9.889 15.2999 9.3776 15.5084C7.06131 16.453 5.5 18.5813 5.5 20.9999C5.5 21.5522 5.05228 21.9999 4.5 21.9999C3.94772 21.9999 3.5 21.5522 3.5 20.9999C3.5 17.6777 5.641 14.8723 8.6224 13.6565C9.1338 13.448 9.71743 13.6935 9.92597 14.2049Z",
    fill: "currentFill"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4333_26388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3557 21.373L21.3246 21.9271C21.0767 21.9947 20.9528 22.0285 20.8513 22.0957C20.7616 22.1551 20.685 22.2332 20.6264 22.325C20.5603 22.4286 20.5266 22.5555 20.4591 22.8093L19.9062 24.8891L19.3663 22.8059C19.3004 22.5516 19.2674 22.4245 19.202 22.3205C19.144 22.2284 19.0679 22.1499 18.9785 22.0899C18.8775 22.0221 18.7538 21.9875 18.5064 21.9183L16.4787 21.3515L18.5098 20.7974C18.7577 20.7298 18.8816 20.696 18.9831 20.6288C19.0728 20.5693 19.1494 20.4913 19.208 20.3996C19.2741 20.2959 19.3078 20.169 19.3753 19.9152L19.9282 17.8354L20.4681 19.9186C20.534 20.1729 20.567 20.3 20.6324 20.404C20.6904 20.4961 20.7665 20.5746 20.8559 20.6346C20.9569 20.7024 21.0806 20.737 21.328 20.8062L23.3557 21.373Z",
    fill: "currentFill"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4333_26388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.178 22.1811L14.1211 22.4377C13.9921 22.469 13.9276 22.4846 13.8748 22.5157C13.8281 22.5433 13.7883 22.5795 13.7578 22.622C13.7235 22.67 13.7059 22.7288 13.6709 22.8465L13.3835 23.8107L13.1021 22.8447C13.0678 22.7269 13.0506 22.6679 13.0165 22.6197C12.9864 22.577 12.9467 22.5405 12.9002 22.5127C12.8476 22.4813 12.7832 22.4652 12.6545 22.4331L11.5991 22.1699L12.6561 21.9134C12.7851 21.8821 12.8495 21.8664 12.9023 21.8353C12.949 21.8077 12.9889 21.7716 13.0193 21.7291C13.0537 21.681 13.0712 21.6222 13.1063 21.5045L13.3937 20.5403L13.675 21.5063C13.7094 21.6242 13.7265 21.6831 13.7606 21.7314C13.7908 21.7741 13.8304 21.8105 13.8769 21.8383C13.9295 21.8698 13.9939 21.8858 14.1227 21.918L15.178 22.1811Z",
    fill: "currentFill"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4333_26388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3172 16.9967L16.8251 17.3513C16.643 17.3946 16.5519 17.4162 16.4774 17.4592C16.4115 17.4973 16.3553 17.5473 16.3123 17.6061C16.2637 17.6725 16.239 17.7538 16.1895 17.9164L15.7839 19.2493L15.3866 17.9139C15.3381 17.751 15.3139 17.6695 15.2657 17.6028C15.2231 17.5438 15.1672 17.4934 15.1015 17.4549C15.0273 17.4115 14.9364 17.3893 14.7545 17.3449L13.2647 16.981L14.7568 16.6264C14.9389 16.5832 15.0299 16.5615 15.1044 16.5185C15.1703 16.4804 15.2266 16.4304 15.2696 16.3717C15.3181 16.3053 15.3429 16.224 15.3924 16.0613L15.798 14.7285L16.1953 16.0638C16.2437 16.2268 16.268 16.3082 16.3161 16.3749C16.3587 16.4339 16.4147 16.4843 16.4804 16.5228C16.5546 16.5663 16.6455 16.5885 16.8273 16.6329L18.3172 16.9967Z",
    fill: "currentFill"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4333_26388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.2771,
    height: 14.7037,
    fill: "white",
    transform: "translate(24.6084 12.9094) rotate(90.1784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4333_26388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.36054,
    height: 4.77184,
    fill: "white",
    transform: "translate(15.7812 20.0027) rotate(90.1784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4333_26388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.0278,
    height: 6.73672,
    fill: "white",
    transform: "translate(19.1685 13.9855) rotate(90.1784)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBots);
export default __webpack_public_path__ + "static/media/icon-bots.867d9da89a92a93a074c05531e21bdcc.svg";
export { ForwardRef as ReactComponent };